/** A suggestion as `GET i/analysis-requests/list` and `GET i/analysis-requests/{id}` answer it, in the stored key order. */
export type AnalysisSuggestion = {
  createdAt: number
  modifiedAt: number
  createdBy: string | null
  modifiedBy: string | null
  id: string
  gameId: string
  gameVersion: string | null
  gameVersionReleaseDate: number | null
  /** 1–5. */
  importance: number
  requestReason: string | null
  /** The suggesting user's e-mail. */
  requestingUser: string
  requestingOrganization: string
  completed: boolean
  completionTime: number
  /** An analyst's e-mail. */
  assignedAnalyst: string | null
  /** HTML. */
  internalComment: string | null
}

/** The fields an analyst changes. Each change is saved at once. */
export type AnalysisSuggestionChange = Partial<Pick<AnalysisSuggestion, 'assignedAnalyst' | 'completed' | 'internalComment'>>

/** A suggested game as `POST games/list` answers it with legacy's fields. */
export type AnalysisSuggestionGame = {
  id: string
  appId?: number
  name: string
  artist?: string
  icon?: string
  icons?: string[]
  /** Empty for a game that has never been analysed. */
  gpsPerMarket?: { [marketIso: string]: number }
}

export enum AnalysisSuggestionType {
  New = 'new',
  Update = 'update',
}

export enum AnalysisSuggestionSort {
  Date = 'date',
  Organization = 'organization',
  User = 'user',
  Importance = 'importance',
  Game = 'game',
}

/** A suggestion with what the page shows about it. */
export type AnalysisSuggestionRow = {
  suggestion: AnalysisSuggestion
  game?: AnalysisSuggestionGame
  /** Unset when `games/list` doesn't return the game. */
  type?: AnalysisSuggestionType
  organizationName?: string
  userName?: string
  analystName?: string
}

export type AnalystOption = { email: string; name: string }

export type AnalysisSuggestionsSummaryData = {
  total: number
  organizationCount: number
  userCount: number
  topOrganization?: { id: string; name?: string; count: number }
  topUser?: { email: string; name?: string; count: number }
  averageImportance: number
  /** Organizations the account server returned, most suggestions first. */
  byOrganization: { name: string; count: number }[]
}
